enum InvitationStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  NOT_STARTED = 'NOT_STARTED'
}

export default InvitationStatus
